import React, { useEffect, useState } from "react";
import { Space, Tooltip, Popconfirm } from "antd";
import { UserAddOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import PageTableLayout from "../../components/Pagetablelayout";
 
export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
 
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("jwt");
      console.log("Token being sent:", token); // ✅ Debug check 1
 
      const res = await axios.get("https://mdgholidaydreams.com/api/users", {
        headers: {
          Authorization: `Bearer ${token}`, // ✅ attach token
        },
      });
 
      console.log("Fetched users:", res.data); // ✅ Debug check 2
      setUsers(res.data);
    } catch (err) {
      console.error("API error:", err);
    }
    setLoading(false);
  };
 
  useEffect(() => {
    fetchUsers();
  }, []);
 
  const columns = [
    {
      title: "USER NAME",
      dataIndex: "username",
      key: "username",
      render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
    {
      title: "EMAIL",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "PHONE NUMBER",
      dataIndex: "phone_number",
      key: "phone_number",
      render: (val) => val || "-",
    },
    {
      title: "COUNTRY",
      dataIndex: "country",
      key: "country",
      render: (val) => val || "-",
    },
    {
      title: "CITY",
      dataIndex: "city",
      key: "city",
      render: (val) => val || "-",
    },
    
    {
      title: "CREATED BY",
      dataIndex: "created_by",
      key: "created_by",
      render: (val) => val || "-",
    },
    {
      title: "ACTIONS",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space size={12}>
          <Tooltip title="Assign Role">
            <UserAddOutlined
              style={{ color: "#800080", fontSize: 18, cursor: "pointer" }}
              onClick={() => console.log("Assign role to", record.id)}
            />
          </Tooltip>
          <Tooltip title="Edit">
            <EditOutlined
              style={{ color: "#22a722", fontSize: 18, cursor: "pointer" }}
              onClick={() => console.log("Edit", record.id)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Popconfirm
              title="Delete this user?"
              okText="Yes"
              cancelText="No"
              okButtonProps={{ danger: true }}
              onConfirm={() => console.log("Delete", record.id)}
            >
              <DeleteOutlined
                style={{ color: "#ef4444", fontSize: 18, cursor: "pointer" }}
              />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];
 
  return (
    <PageTableLayout
      breadcrumb={["System", "Users"]}
      title="Users"
      addButtonLabel="Add User"
      onAdd={() => console.log("Add User clicked")}
      columns={columns}
      dataSource={users}
      loading={loading}
      onRefresh={fetchUsers}
      rowKey="id"
    />
  );
}